var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M242.1,450.2c-110.4,0-200.2-89.8-200.2-200.2S131.7,49.8,242.1,49.8S442.2,139.6,442.2,250S352.5,450.2,242.1,450.2z    M242.1,81.8c-92.7,0-168.2,75.4-168.2,168.2s75.4,168.2,168.2,168.2S410.2,342.7,410.2,250S334.8,81.8,242.1,81.8L242.1,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M315.9,302.8c-4.2,0-8.3-1.7-11.3-4.7l-62.5-62.5l-62.5,62.5c-6.3,6.2-16.5,6-22.6-0.3c-6-6.2-6-16.1,0-22.3l73.6-73.6   c3-3,7.1-4.7,11.3-4.7h0.5c4.2,0,8.3,1.7,11.3,4.7l73.6,73.6c6.2,6.3,6.2,16.4,0,22.6C324.2,301.1,320.2,302.8,315.9,302.8   L315.9,302.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLess);
export default __webpack_public_path__ + "static/media/less.3e0263cef99dd643558c8b1c981ac9a7.svg";
export { ForwardRef as ReactComponent };